import { useCallback, useLayoutEffect, useMemo } from 'react';

import { flip, shift, useDismiss, useFloating, useInteractions } from '@floating-ui/react';

export function useContextMenu({ position, onClose }) {
  const isOpen = !!position;

  const virtualRef = useMemo(() => {
    if (!position) return null;

    return {
      getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          x: position.x,
          y: position.y,
          left: position.x,
          right: position.x,
          top: position.y,
          bottom: position.y,
        };
      },
    };
  }, [position]);

  const handleOpenChange = useCallback(
    function handleContextMenuOpenChange(open) {
      if (!open) onClose();
    },
    [onClose],
  );

  const { refs, floatingStyles, context, update } = useFloating({
    open: isOpen,
    onOpenChange: handleOpenChange,
    placement: 'right-start',
    middleware: [
      flip({
        fallbackPlacements: ['right-start', 'left-start', 'bottom-start', 'top-start'],
      }),
      shift({ padding: 8 }),
    ],
  });

  const dismiss = useDismiss(context);
  const { getFloatingProps } = useInteractions([dismiss]);

  useLayoutEffect(() => {
    if (!virtualRef) return;

    refs.setReference(virtualRef);
    update();
  }, [refs, update, virtualRef]);

  return { refs, floatingStyles, getFloatingProps };
}
